import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { log } from 'utils';
import { getRole } from 'utils/secrets';
import ListView from './ListView';
import MasterConfigView from './MasterConfigView';
import AddChildView from './AddChildView';
import PreviewView from './PreviewView';
import './DynamicComp.css';

function DynamicComp() {
  const [view, setView] = useState('list');
  const [editingChild, setEditingChild] = useState(null);
  const [draftFields, setDraftFields] = useState(null);
  const [hasOrderChanged, setHasOrderChanged] = useState(false);
  const [role, setRole] = useState(null);

  const { siteId } = useParams();
  const userData = useSelector((state) => state.auth.userData);

  useEffect(() => {
    getRole()
      .then(setRole)
      .catch((error) => log('Error retrieving role:', error));
  }, []);

  // Master Config and New Child both need "Create Dynamic Components" on /roles.
  // Hidden until the role loads.
  let canCreate = false;
  if (role === 'superadmin') {
    canCreate = true;
  } else if (userData && userData.roleAccess) {
    const siteAccess = userData.roleAccess.access.find(
      (access) => access.siteId === siteId
    );
    canCreate = Boolean(
      siteAccess &&
        siteAccess.dynamiccomponent &&
        siteAccess.dynamiccomponent.create
    );
  }

  if (view === 'masterConfig') {
    return (
      <MasterConfigView
        onBack={() => {
          setDraftFields(null);
          setHasOrderChanged(false);
          setView('list');
        }}
        onPreview={() => setView('preview')}
        draftFields={draftFields}
        onDraftFieldsChange={setDraftFields}
        hasOrderChanged={hasOrderChanged}
        onHasOrderChangedChange={setHasOrderChanged}
      />
    );
  }

  if (view === 'addChild') {
    return (
      <AddChildView
        onBack={() => setView('list')}
        onMasterConfig={canCreate ? () => setView('masterConfig') : undefined}
      />
    );
  }

  if (view === 'editChild') {
    return (
      <AddChildView
        onBack={() => {
          setView('list');
          setEditingChild(null);
        }}
        editData={editingChild}
        onMasterConfig={canCreate ? () => setView('masterConfig') : undefined}
      />
    );
  }

  if (view === 'preview') {
    return <PreviewView onBack={() => setView('masterConfig')} previewFields={draftFields} />;
  }

  return (
    <ListView
      onMasterConfig={canCreate ? () => setView('masterConfig') : undefined}
      onAddChild={canCreate ? () => setView('addChild') : undefined}
      onEditChild={(child) => {
        setEditingChild(child);
        setView('editChild');
      }}
    />
  );
}

export default DynamicComp;
